import { Button } from '@cian/ui-kit';
import { IconToggleHeartOn16, IconToggleHeartOff16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

interface IFavouriteButtonProps {
  isFavorite: boolean;
  onClick(): void;
}

export const FavouriteButton: React.FC<IFavouriteButtonProps> = ({ isFavorite, onClick }) => {
  const icon = isFavorite ? (
    <IconToggleHeartOn16 color="icon-negative-default" />
  ) : (
    <IconToggleHeartOff16 color="icon-negative-default" />
  );
  const label = isFavorite ? 'В избранном' : 'В избранное';

  return (
    <Button theme="fill_white_secondary" onClick={onClick} beforeIcon={icon} size="XS">
      {label}
    </Button>
  );
};
